<template>
    <div v-bind="result.attributes" class="product-card-2__wrapper">
        <div class="product-card product-card-2">
            <a :href="result.detailPage">
                <img v-if="result.picture" :src="result.picture.src" :alt="result.picture.alt">
            </a>
<!--            <def-like :result="result.id"/>-->
<!--            <div v-if="getPageWidth() >= 992" @click.prevent="openQuickView = true" class="product-card__view">-->
<!--                {{ messages.detail }}-->
<!--            </div>-->
            <div class="product-card__block">
                <span v-if="result.printDiscountPercent"
                      class="product-card__discount">{{ result.printDiscountPercent }}</span>
                <a :href="result.detailPage" class="product-card__name">{{ result.name }}</a>
                <div v-if="result.price && result.price.printPrice">
                    <span class="product-card__price">{{ result.price.printPrice }}</span>
                    <span v-if="+result.price.printPrice !== +result.price.printPriceOld"
                          class="product-card__oldPrice">{{ result.price.printPriceOld }}</span>
                </div>
            </div>
        </div>
<!--        <div v-if="getPageWidth() >= 992">-->
<!--            &lt;!&ndash;Быстрый просмотр&ndash;&gt;-->
<!--            <vue-popup v-model="openQuickView" :styles="{maxWidth: '1024px'}">-->
<!--                <product-detail :result="result" @changeData="changeData"/>-->
<!--                <div class="quick-view-form">-->
<!--                    <div class="quick-view-form__text">-->
<!--                        Хочете купити швидко по телефону? без заповнення форм-->
<!--                    </div>-->
<!--                    <form class="quick-view-form__form def-validation">-->
<!--                        <input type="text" class="def-input def-tel-mask" required>-->
<!--                        <button type="submit" class="def-button">-->
<!--                            купити в 1 клік-->
<!--                        </button>-->
<!--                    </form>-->
<!--                </div>-->
<!--            </vue-popup>-->
<!--        </div>-->
    </div>
</template>

<script>
    const item = require('../../../MOCKED_DATA/catalog-page').catalogData.catalogSectionList.items[0];

    export default {
        name: 'product-card-2',
        selector: '.product-card-2',
        props: {
            result: {
                type: Object,
                default: () => item
            },
            messages: {
                type: Object,
                default: () => ({
                    detail: 'Детальнее'
                })
            },
            'changeData': {
                type: [Function, Object],
            }
        },
        updated() {
            if (this.openQuickView) {
                // ципляем маску для инпута телефона
                $('body').trigger('init-form');
            }
        },
    }
</script>

<style lang="scss" scoped>
.product-card {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    font-weight: 500;
    color: #191918;
    font-size: rem(14);
    letter-spacing: 0.08em;
    position: relative;
    height: 100%;
    @include point-md {
        font-size: rem(16);
    }

    &__discount {
        display: block;
        color: var(--discount-color);
        margin-bottom: 4px;
        font-size: rem(10);
        letter-spacing: 0.1em;
        height: 12px;
        @include point-md {
            font-size: rem(12);
        }
    }

    &__name {
        display: block;
        margin-bottom: 12px;
        @include point-md {
            margin-bottom: 18px;
        }
    }

    &__price {
        color: #363636;
    }

    &__oldPrice {
        color: #757575;
        text-decoration: line-through;
    }

    &__block {
        padding: 8px;
        @include point-md {
            padding: 16px;
        }
        @include point-lg {
            padding: 12px 24px 24px;
        }
    }

    &__view {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        background: var(--background-colour-primary);
        font-weight: 500;
        font-size: rem(14);
        text-transform: uppercase;
        color: #467496;
        opacity: 0;
        transition: .3s linear opacity;
        &:hover{
            cursor: pointer;
        }
    }

    &:hover {
        .product-card__view {
            opacity: 1;
        }
    }

    .def-like {
        position: absolute;
        top: 16px;
        right: 16px;
    }
}
.product-card-2{
    img{
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }
    &__wrapper{
        height: 100%;
    }
}

    //.quick-view-form {
    //    background: #F7F8F9;
    //    display: flex;
    //    margin: 0 -20px -20px;
    //    padding-left: 20px;
    //    padding-right: 20px;
    //
    //    &__text {
    //        display: flex;
    //        align-items: center;
    //        font-weight: 500;
    //        font-size: rem(16);
    //        letter-spacing: 0.08em;
    //        text-transform: uppercase;
    //        color: #191918;
    //        height: 80px;
    //        width: 58.3333333333%;
    //    }
    //
    //    &__form {
    //        display: flex;
    //        align-items: center;
    //        height: 80px;
    //        width: 41.6666666667%;
    //
    //        input {
    //            display: block;
    //            flex-grow: 1;
    //        }
    //    }
    //
    //    .def-button {
    //        font-weight: 500;
    //        font-size: rem(14);
    //        text-transform: uppercase;
    //        color: var(--text-colour-secondary);
    //        background: #B8D9EC;
    //
    //        &:hover {
    //            color: var(--text-colour-secondary);
    //        }
    //    }
    //}

</style>